import React, { FormEventHandler, useMemo, useState } from 'react';
import {
  targetTitleErrorToString,
  TargetTitleValidateError,
} from 'components/features/target-achievement-support/utils/validate';
import {
  Error,
  errorBgColorTailwind,
  Errors,
} from '../components/commons/Error';

export const useTargetTitleForm = (
  titleErrors: TargetTitleValidateError[],
  initialTargetTitle?: string
): {
  TargetTitleForm: React.ReactElement;
  isTitleError: boolean;
  targetTitle: string;
} => {
  const [targetTitle, setTargetTitle] = useState<string>(
    initialTargetTitle ?? ''
  );
  const onInputTargetTitle: FormEventHandler<HTMLInputElement> = event =>
    setTargetTitle(event.currentTarget.value);
  const isTitleError = !!titleErrors.length;
  const TargetTitleForm = useMemo(
    (): React.ReactElement => {
      return (
        <div>
          <input
            value={targetTitle}
            onChange={onInputTargetTitle}
            className={`h-10 rounded-lg w-full border ${
              isTitleError ? `bg-${errorBgColorTailwind}` : ''
            } border-bluegray-400 px-4`}
            placeholder="タイトルを入力"
          />
          {isTitleError && (
            <Errors className="mt-1">
              {titleErrors.map(e => (
                <Error
                  {...{
                    error: e,
                    errorToString: targetTitleErrorToString,
                  }}
                  key={e}
                />
              ))}
            </Errors>
          )}
        </div>
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [targetTitle, titleErrors]
  );
  return { TargetTitleForm, isTitleError, targetTitle };
};
